import { useContext } from 'react'

import { INodeContext } from 'common/builder/components/chart/FlowChart/flowChartInterfaces'
import { NodeContext } from 'common/builder/controllers/chart/FlowChart/nodes/shared/NodeContext'

export const useFlowChartNodeContext = () => {
  return useContext(NodeContext) as INodeContext
}
